<h2 mat-dialog-title class="dlg-title">
  <mat-icon class="dlg-icon">price_change</mat-icon>
  Ce produit n'a pas de prix
</h2>

<mat-dialog-content class="dlg-content">
  @if (data.productName) {
    <p class="dlg-product-name">{{ data.productName }}</p>
  }
  <p class="dlg-warning">Veuillez saisir un prix de vente pour continuer</p>

  @if (isMultiple) {
    <section class="packaging-section">
      <p class="packaging-scanned">Conditionnement scanné : <strong>{{ packagingUnit }} de {{ data.qtybaseuom }} {{ baseUnitPlural }}</strong>.</p>
      <p class="packaging-instruction">Indiquez le prix <strong>par {{ baseUnit }}</strong> : le prix du conditionnement sera calculé automatiquement ({{ data.qtybaseuom }} × le prix saisi).</p>
    </section>
  } @else if (data.packagingName) {
    <p class="packaging-scanned">Conditionnement scanné : <strong>{{ data.packagingName }}</strong></p>
  }

  @if (data.productId || data.productName) {
    <section class="info-section">
      <h3 class="section-title">Produit</h3>
      <div class="info-grid">
        @if (data.productId) {
          <span class="info-label">ID</span>
          <span class="info-value">{{ data.productId }}</span>
        }
        @if (data.productName) {
          <span class="info-label">Nom</span>
          <span class="info-value">{{ data.productName }}</span>
        }
      </div>
    </section>
  }

  <section class="price-section" [class.price-ht]="data.is_ht" [class.price-ttc]="!data.is_ht">
    <h3 class="section-title">{{ priceLabel }}</h3>
    <div class="price-input-wrapper">
      <input
        class="price-input"
        type="number"
        [formControl]="priceInput"
        placeholder="0.00"
        [min]="data.freePrice ? null : 0.01"
        step="0.01"
        autofocus
        (keydown.enter)="onConfirm()"
      />
      <span class="price-currency">€</span>
    </div>
    @if (priceInput.invalid && priceInput.touched) {
      <p class="price-error">Veuillez saisir un prix valide{{ data.freePrice ? '' : ' (> 0)' }}</p>
    }
    @if (packagingTotal !== null) {
      <p class="packaging-total">Soit <strong>{{ packagingTotal | number: '1.2-2' }} €</strong> {{ data.is_ht ? 'HT' : 'TTC' }} pour les {{ data.qtybaseuom }} {{ baseUnitPlural }} du conditionnement</p>
    }
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-flat-button class="error" (click)="onCancel()">
    Annuler
  </button>
  <button mat-flat-button class="error" (click)="onConfirm()" [disabled]="priceInput.invalid">
    <mat-icon>check</mat-icon>
    Confirmer
  </button>
</mat-dialog-actions>
